import axios from "axios";
import { logout } from "../lib/auth";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// エントリー商材一覧取得
export async function getSaleCompanyEntryProducts(id: string) {
  try {
    const path = "saleCompanyEntryProducts";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return {
      sudDatas: response.data.fetch_data,
      productDatas: response.data.product_data,
    };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}

// エントリー商材登録
export async function postSaleCompanyEntryProducts(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "saleCompanyEntryProducts";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}
